<section class="list-filters-panel">
	<div class="list-filters-panel__bar">
		<mat-icon>search</mat-icon>
		<span>{{ title() }}</span>
	</div>

	<div class="list-filters-panel__grid">
		<ng-content select="[listFilters]" />
	</div>

	<div class="list-filters-panel__actions">
		<div class="list-filters-panel__extra-actions">
			<ng-content select="[listFiltersActions]" />
		</div>
		<button
			type="button"
			class="list-filters-panel__clear-button"
			(click)="clearClicked.emit()"
			[disabled]="clearDisabled()"
		>
			{{ clearLabel() }}
			<mat-icon>autorenew</mat-icon>
		</button>
		<button
			type="button"
			class="list-filters-panel__search-button"
			(click)="searchClicked.emit()"
			[disabled]="searchDisabled()"
		>
			{{ searchLabel() }}
			<mat-icon>search</mat-icon>
		</button>
	</div>
</section>
